import Analytics from "../Analytics";
import { COUNTRY } from "utils/constants";
import { lower } from "utils/helpers";
import get from "lodash/get";
import includes from "lodash/includes";
import { EVAM_EVENTS } from "constants/AnalyticsTypeConstants";
import { sendCustomEvamData } from "../utils/helpers";
import { constructEvamEventInfo } from "analytics/utils/evamAnalytics/evamAnalyticsHelper";

class EvamAnalytics extends Analytics {
  /**
   * Pushes analytics events to Evam if they are whitelisted
   * @param {string} event - Type of event provided by analyticsConstructor
   * @param {Object} data - Data associated with the redux action
   * @param {string} message - Message associated with the event
   * @param {Object} reduxStore - Redux store instance
   * @param {string} country - Country code (defaults to lowercase COUNTRY constant)
   */
  pushEvent(event, data, message, reduxStore, country = lower(COUNTRY)) {
    if (!this.isEventWhitelisted(event)) {
      return;
    }

    const eventData = this.processEventData(event, data, reduxStore);
    this.sendEventIfValid(eventData);
  }

  /**
   * Checks if the event is whitelisted in EVAM_EVENTS
   * @param {string} event - Event to check
   * @returns {boolean} - Whether the event is whitelisted
   */
  isEventWhitelisted(event) {
    return includes(EVAM_EVENTS, event);
  }

  /**
   * Processes event data using constructEvamEventInfo
   * @param {string} event - Event type
   * @param {Object} data - Event data
   * @param {Object} reduxStore - Redux store
   * @returns {Object} - Processed event data
   */
  processEventData(event, data, reduxStore) {
    return constructEvamEventInfo(event, data, reduxStore);
  }

  /**
   * Sends event data if it contains a valid event name
   * @param {Object} eventData - Processed event data
   */
  sendEventIfValid(eventData) {
    const eventName = get(eventData, "event.name");
    const eventProperties = get(eventData, "event.properties");
    if (eventName) {
      sendCustomEvamData(eventName, eventProperties);
    }
  }
}

export default new EvamAnalytics();
